<template>
  <div class="layout">
    <div class="menu">
      <div class="top">
        <el-image :src="logoImage" class="logo-image"></el-image>
        <span class="logo-txt">{{ systemName }}</span>
      </div>
      <Menu :menuList="menuList"></Menu>
    </div>

    <div class="container_box">
      <div class="header-box">
        <div class="header">
          <div class="header-text"></div>
          <div class="header-right">
            <div class="notice">
              <!-- 关键：这里加 .stop 阻止冒泡 -->
              <div class="icon-num" @click.stop="checkNum()">
                <el-image :src="noticeUrl" class="notice-image"></el-image>
                <div class="notice-num" v-if="noticeNum > 0">
                  {{ noticeNum }}
                </div>
              </div>
              <div class="popover-content" v-if="showMessage" ref="messagePopover">
                <div class="list-top-box">
                  <div class="popover-title">
                    <span class="title-left">消息中心</span>
                    <span @click="showMessage = false" style="cursor: pointer">
                      <i class="el-icon-close"></i>
                    </span>
                  </div>
                </div>
                <div class="list-content" v-loading="tableOptions.loading">
                  <template v-if="tableData && tableData.length > 0">
                    <div class="list-content-box" v-for="item in tableData" :key="item.msgId">
                      <div class="list-title">
                        <div class="list-title-txt">
                          <el-image :src="messageImage" class="list-title-img"></el-image>
                          <span :class="item.read?'':'unread-dot'">{{ item.sourceTypeName }}</span>
                        </div>
                        <div class="list-date">{{ item.msgTime }}</div>
                      </div>
                      <div class="list-box">
                        <span class="list-box-content">
                          {{ item.msgContent }}
                        </span>
                        <span class="operate" v-if="item.msgStatus === 0" @click="toHandle(item)">前往处理</span>
                      </div>
                    </div>
                  </template>
                  <el-empty :image-size="50" v-else></el-empty>
                </div>
                <div class="pagination-box">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="tableOptions.currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="tableOptions.pageSize"
                    :page-count="tableOptions.pageCount"
                    background
                    layout="total, prev, pager, next"
                    :total="tableOptions.total" />
                </div>
              </div>
            </div>
            <div class="right-menu">
              <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
                <div class="dropdown-box">
                  <div class="photo-box">
                    {{ username ? username.charAt(0) : "" }}
                  </div>
                  <div class="phone-name">{{ username }}</div>
                  <i class="el-icon-caret-bottom el-icon--right"></i>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="toPersanlCenter()">个人中心</el-dropdown-item>
                  <el-dropdown-item @click.native="updatePassword()">修改密码</el-dropdown-item>
                  <el-dropdown-item divided @click.native="loginOut()">
                    <span>退出登录</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
        <crumb></crumb>
      </div>

      <div class="container" ref="container">
        <router-view></router-view>
      </div>
    </div>
    <update-password ref="updatePassword"></update-password>
    <personal-center ref="personalCenter"></personal-center>
  </div>
</template>

<script>
import tableMixin from "@/mixin/tableMixin";
import Socket from "@/utils/websocket";
import Menu from "./components/menu.vue";
import UpdatePassword from "@/Layout/components/updatePassword.vue";
import personalCenter from "@/Layout/components/personalCenter.vue";
import { getMessageList, getMessageNum, readNotice } from "./api";
import crumb from "./components/crumb.vue";

export default {
  components: { UpdatePassword, personalCenter, Menu, crumb },
  mixins: [tableMixin],
  data() {
    return {
      getTableMethod: getMessageList,
      logoImage: require("@/assets/imgs/logo.jpg"),
      messageImage: require("@/assets/imgs/message.png"),
      loginOutUrl: require("@/assets/img/icon23.png"),
      noticeUrl: require("@/assets/images/header-msg.png"),
      selectYear: "",
      yearList: [],
      menuList: [],
      username: localStorage.getItem("username"),
      merchantName: "",
      totalMsg: "",
      showMessage: false,
      noticeNum: 0,
      isRead: false,
      isImmediatelyGetData: false,
      timer: null,
      loading: false,
      tableData: [],
      socket: null,
      sourceType: [
        {
          type: 1,
          tab: 2,
          path: "/CustomerServiceWorkbench/PendingPriceOrder/index",
          name: "待核价订单"
        },
        {
          type: 2,
          tab: 1,
          path: "/CustomerServiceWorkbench/PendingPriceOrder/index",
          name: "待审核订单"
        },
        {
          type: 3,
          path: "/CustomerServiceWorkbench/ComplaintSuggestionManagement/index",
          name: "投诉建议"
        },
        {
          type: 4,
          path: "/FinancialManagement/InvoicesApply/index",
          name: "发票开具申请"
        },
        {
          type: 5,
          path: "/ApprovalCenter/DriverInformationApproval/index",
          name: "司机入驻审批申请"
        },
        {
          type: 6,
          path: "/ApprovalCenter/OrderCancelApproval/index",
          name: "司机取消订单申请"
        },
        {
          type: 7,
          path: "",
          name: "司机流失预警"
        },
        {
          type: 8,
          path: "/SchedulingWorkbench/OrderScheduling/index",
          name: "订单调度"
        },
        {
          type: 9,
          path: "/CustomerServiceWorkbench/ReturnOrder/index",
          name: "待回单订单跟单"
        }
      ]
    };
  },
  computed: {
    systemName: function () {
      let companyType = localStorage.getItem("companyType");
      let companyName = localStorage.getItem("companyName");
      if (Number(companyType) === 10) {
        return "拼满运（服务商）"
      } else if (Number(companyType) === 2) {
        return `拼满运 - ${companyName}`
      } else {
        return "拼满运"
      }
    }
  },
  watch: {
    showMessage(val) {
      if (!val) {
        this.tableData = [];
        // 关闭时移除监听，防止多次绑定
        document.removeEventListener('click', this.closeHandler);
      }
    }
  },
  created() {
    this.menuList = JSON.parse(localStorage.getItem("menus")) || [];
    if (this.menuList && this.menuList.length > 0) {
      this.menuList.forEach((item) => {
        if (item.children && item.children.length > 0) {
          item.children.forEach((item2) => {
            if (item2.menuType === 2) item.children = [];
            if (item2.children && item.children.length > 0) {
              item2.children.forEach((item3) => {
                if (item3.menuType === 2) item2.children = [];
              });
            }
          });
        }
      });
    }
  },
  mounted() {
    this.getMessage();
    this.timer = setInterval(() => {
      this.getMessage();
    }, 5000);
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
    document.removeEventListener('click', this.closeHandler);
    if (this.socket) this.socket.close();
  },
  methods: {
    toHandle(item) {
      // 1. 获取配置
      let config = this.getSourceType(item.sourceType);

      // 2. 找不到 或 没有路径 → 提示并return，不跳转
      if (!config || !config.path) {
        this.$message.warning('该消息暂无对应处理页面');
        this.showMessage = false;
        return;
      }

      // 3. 正常跳转
      this.showMessage = false;
      this.$router.push({
        path: config.path,
      });
    },
    getSourceType(type) {
      return this.sourceType.find(item => item.type === type) || {};
    },
    initWebSocket() {
      this.socket = new Socket({
        url: `${process.env.VUE_APP_SOCKET_PATH}`,
        messageCb: (data) => {
          this.handleMessage(data);
        }
      });
    },
    handleMessage(res) {
      // console.log("收到消息:", res);
    },
    toPersanlCenter() {
      this.$refs.personalCenter.init();
    },
    handleDetail(row) {
      this.$refs.detail.init(row);
    },
    checkYi(b) {
      this.isRead = b;
      this.tableOptions.currentPage = 1;
      this.tableData = [];
    },
    checkNum() {
      this.showMessage = true;
      this.tableOptions.currentPage = 1;
      this.getTableData();
      // 绑定外部关闭监听
      document.addEventListener('click', this.closeHandler);
    },
    // 抽成独立方法，方便移除
    closeHandler(e) {
      if (!this.$refs.messagePopover) return;
      // 点击不在弹窗内部 → 关闭
      if (!this.$refs.messagePopover.contains(e.target)) {
        this.showMessage = false;
        document.removeEventListener('click', this.closeHandler);
      }
    },
    handleSizeChange(val) {
      this.tableOptions.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.tableOptions.currentPage = val;
      this.getTableData();
    },
    getTableData() {
      let params = {
        currentPage: this.tableOptions.currentPage,
        pageSize: this.tableOptions.pageSize,
        param: { read: "" }
      };
      this.tableOptions.loading = true;
      getMessageList(params)
        .then((res) => {
          this.tableOptions.loading = false;
          if (res.code === 200) {
            if (
              this.tableOptions.currentPage > 1 &&
              (!res.data || !res.data.data.length)
            ) {
              this.tableOptions.currentPage--;
              this.getTableData();
              return;
            }
            this.tableData = res.data.data;
            if (this.tableData && this.tableData.length > 0) {
              this.readNoticeData()
            }
            this.tableOptions.total = res.data.totalCount;
            this.tableOptions.pageCount = res.data.totalPage;
          }
        })
        .catch(() => {
          this.tableOptions.loading = false;
        });
    },
    getMessage() {
      getMessageNum().then((res) => {
        if (res.code === 200) {
          this.noticeNum = res.data.unread;
        }
      });
    },
    readNoticeData() {
      let ids = []
      this.tableData.forEach((item) => {
        if (!item.read) {
          ids.push(item.msgId);
        }
      })
      if (ids && ids.length > 0) {
        readNotice({ msgIds: ids }).then((res) => {
          if (res.code === 200) {
            this.getMessage();
            this.resetData()
          }
        });
      }

    },
    resetData() {
      let arr = [...this.tableData]
      arr.forEach(item => {
        item.read = true
      })
      this.tableData = [...arr]
    },
    // checkDetail(item) {
    //   if (item.read) {
    //     this.handleDetail(item);
    //   } else {
    //     readNotice({ noticeId: item.noticeId }).then((res) => {
    //       if (res.code === 200) {
    //         this.handleDetail(item);
    //         this.getMessage();
    //         this.getTableData();
    //       }
    //     });
    //   }
    // },
    updatePassword() {
      this.$refs.updatePassword.init();
    },
    loginOut() {
      this.$confirm("确定退出登录么?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          localStorage.clear();
          sessionStorage.clear();
          setTimeout(() => {
            this.$router.replace({ name: "Login" });
          }, 100);
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.layout {
  width: 100%;
  height: 100%;
  display: flex;
  background-color: #f2f2f5;

  .menu {
    width: 2.2rem;
    flex-shrink: 0;
    height: 100%;
    //position: relative;
    overflow: hidden;
    .top {
      height: 0.6rem;
      display: flex;
      align-items: center;
      padding-left: 0.24rem;
      background-color: #ffffff;
      border-bottom: 0.01rem solid #e3e7ed;
      box-sizing: border-box;
      .logo-txt {
        //width: 6rem;
        font-weight: 600;
        font-size: 0.16rem;
        color: #000000;
        font-family: pr, serif;
        padding-left: 0.2rem;
        position: absolute;
        left: 0.6rem;
        z-index: 10;
        &::before {
          content: "";
          position: absolute;
          left: 0.1rem;
          top: 0.02rem;
          width: 0.01rem;
          height: 0.12rem;
          background-color: #e3e7ed;
        }
      }
      .logo-image {
        width: 0.4rem;
        height: 0.4rem;
        font-weight: bold;
      }
    }
  }
  .dropdown-box {
    display: flex;
    align-items: center;
    cursor: pointer;
    .photo-box {
      width: 0.28rem;
      height: 0.28rem;
      background: #2bd5bc;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: pr, serif;
      font-weight: 400;
      font-size: 0.12rem;
      color: #ffffff;
      border-radius: 50%;
    }
    .phone-name {
      font-weight: 500;
      font-size: 14px;
      color: #202429;
      padding-left: 0.08rem;
    }
  }
  .container_box {
    flex: 1;
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: url("~@/assets/imgs/bg.png") no-repeat;
    background-size: 100% 100%;
    background-color: #ffffff;
    .header-box {}
    .header {
      flex-shrink: 0;
      width: 100%;
      height: 0.6rem;
      background-color: #ffffff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      padding: 0 0.24rem;
      border-bottom: 0.01rem solid #e3e7ed;
      .header-text {
        font-weight: 500;
        font-size: 0.24rem;
        color: #111827;
        line-height: 0.31rem;
        font-family: pm;
      }
      .header-right {
        display: flex;
        align-items: center;
        .notice {
          width: 0.18rem;
          height: 0.2rem;
          position: relative;
          margin-right: 0.4rem;
          cursor: pointer;
          .popover-content {
            width: 6rem;
            max-height: 8rem;
            background: #ffffff;
            box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
            border-radius: 8px;
            position: absolute;
            right: 0;
            top: 0.5rem;
            z-index: 1000;
            display: flex;
            flex-direction: column;
            overflow: hidden;
            .list-top-box {
              .popover-title {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0.16rem 0.24rem 0.12rem;
                background: #f7f8fb;
                .title-left {
                  font-size: 0.16rem;
                  color: #1f2329;
                }
                .el-icon-close:hover {
                  color: red;
                }
              }
            }
            .list-content {
              padding: 0.2rem;
              overflow-y: auto;
              .list-content-box {
                padding: 0.2rem 0.16rem;
                border-radius: 0.06rem;
                &:hover {
                  background: #f5f5f5;
                }
              }
              .list-title {
                font-size: 0.14rem;
                color: #212533;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .list-title-txt {
                  flex: 1;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  padding-right: 0.4rem;
                  height: 0.2rem;
                  color: #434343;
                  font-weight: bold;
                  .list-title-img {
                    width: 0.12rem;
                    height: 0.12rem;
                    margin-right: 0.04rem;
                  }
                  .unread-dot{
                    position: relative;
                    &:after {
                      position: absolute;
                      content: "";
                      right: -0.2rem;
                      top: 0.03rem;
                      width: 0.12rem;
                      height: 0.12rem;
                      background: red;
                      border-radius: 50%;
                    }
                  }
                }
                .list-date {
                  flex-shrink: 0;
                }
              }
              .list-box {
                display: flex;
                align-items: center;
                margin-top: 0.12rem;
                .list-box-content {
                  color: #434343;
                  padding-left: 0.16rem;
                }
                .operate {
                  color: #1269ff;
                  padding-left: 0.06rem;
                  cursor: pointer;
                  &:hover {
                    text-decoration: underline;
                  }
                }
              }
            }
          }
        }
        .notice-image {
          width: 100%;
          height: 100%;
        }
        .notice-num {
          position: absolute;
          top: -0.08rem;
          left: 0.1rem;
          background: #ff5967;
          color: #ffffff;
          padding: 0.02rem;
          font-size: 0.12rem;
          border-radius: 0.06rem;
          border: 0.01rem solid #ffffff;
        }
      }
    }
    .container {
      width: 100%;
      height: calc(100% - 1.4rem);
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      padding: 0 0.16rem 0 0.2rem;
      border-radius: 0.08rem;
      overflow: hidden;
      .container-content {
        flex: 1;
        width: 100%;
        background-color: #ffffff;
        border-radius: 0.08rem;
        margin-bottom: 0.2rem;
      }
    }
    .pagination-box {
      background-color: #ffffff;
      text-align: right;
      padding: 0.1rem 0.1rem 0.1rem 0;
    }
  }
}
</style>
